/**
 * Quick Rolls button behavior, extracted as a pure function so it can be
 * unit-tested without a DOM (the frontend vitest setup runs in a jsdom-free
 * node environment — see vitest.config.ts).
 *
 * The dice IconButton in MessageInput was a dead placeholder. The minimal,
 * legitimate fix is to make it perform its obviously-intended shortcut:
 * prefill the chat input with the roll-command prefix so the user can type a
 * dice notation. The richer quick-roll panel remains separate feature work.
 */

/** The roll-command prefix shown in the composer tip (e.g. `/r 1d20+5`). */
export const QUICK_ROLL_PREFIX = '/r '

/**
 * Returns the input value the chat composer should hold after the Quick Rolls
 * button is clicked: the roll prefix, ready for the user to append notation.
 */
export function quickRollInputValue(): string {
  return QUICK_ROLL_PREFIX
}
